// TODO document this file!

// TODO organise this better

import { AiFillAlert, AiFillDatabase, AiFillPieChart, AiOutlineAreaChart, AiOutlineLineChart } from "react-icons/ai";
import { MdAccountBalance, MdCompost, MdDashboard, MdRadar, MdTrackChanges } from "react-icons/md";
import { FaBalanceScale, FaBookOpen, FaLuggageCart, FaTruck, FaUserCog } from "react-icons/fa";
import {
  BsCollectionFill,
  BsFillBarChartFill,
  BsFillGearFill,
  BsPassFill,
  BsPatchExclamationFill,
  BsPieChartFill,
} from "react-icons/bs";
import { ChartBarHorizontal, ChartPie, GearSix, NotePencil, Planet, TreeStructure, Truck } from "@phosphor-icons/react";
import { HiUsers } from "react-icons/hi";
import { HiMiniCog, HiMiniSquaresPlus, HiMiniDocumentText } from "react-icons/hi2";
import { GrNotes } from "react-icons/gr";
import { RiProgress3Fill } from "react-icons/ri";
import { GoFileMedia } from "react-icons/go";
import {
  Dashboard,
  NetZeroStrategy,
  OrganisationQuestionnaires,
  OrganizationQuestionnaireWrapper,
  SupplierAdminDashboard,
  SupplierEmissionsReport,
  SupplierNetZeroStrategy,
  SupplierNotes,
  SupplierQuestionnaire,
  SupplierQuestionnaires,
  SupplierResources,
  SupplierSettings,
  SuppliersLocations,
  SupplierUserNotes,
  TaskAssigneesTemplate,
} from "../pages";
import { ChakraProvider, Text } from "@chakra-ui/react";
import { PhysicalRisk } from "../pages/PhysicalRisk";
import { SupplierPhysicalRiskQuestionnaire } from "../pages/SupplierPhysicalRiskQuestionnaire";
import { SupplierDashboard } from "../pages/SupplierDashboard";
import ESGExplorer from "../pages/ESGExplorer/ESGExplorer";
import {
  CarbonPrice,
  ClimateActionTracker,
  ClimatePolicyRadar,
  ExposureToLitigation,
  MaterialIssuesAndIndicators,
  SustainableFinanceRegulation,
} from "../pages/ScenarioPlanning/components";
import { t } from "i18next";
import { ConversionFactors, MultimodalTransportation, Users, Prompts, DimensionManagementPage } from "../pages/Settings";
import EntityPage from "pages/Settings/Entities/EntityPage";
import { EmissionsReports } from "../pages/Reports/EmissionsReports";
import { SupplierReports } from "../pages/Reports/SupplierReports";
import { OrganizationPlanning } from "../pages/DataEntryPlanning/components/OrganizationPlanning";
import { SuppliersPlanning } from "../pages/DataEntryPlanning/components/SuppliersPlanning";
import { carbonDioxideSvgIcon, netZeroStrategySvgIcon } from "../utils";
import { SupplierManagement } from "../pages/SupplierManagement";
import { SuppliersEmissionsDashboard } from "../pages/SuppliersEmissionsDashboard";
import { CompanyEmissionsDashboard } from "../pages/Reports/CompanyEmissionsDashboard";
import CSRDPlanning from "../pages/CSRD/CSRDPlanning/CSRDPlanning";
import { CSRDQuestionnaires } from "../pages/CSRD/CSRDQuestionnaires";
import { CSRDReport } from "../pages/CSRD/CSRDReport";
import CSRDQuestionnaireWrapper from "../pages/CSRD/CSRDQuestionnaire/CSRDQuestionnaireWrapper";
import { CSRDViewProgress } from "../pages/CSRD/CSRDViewProgress";
import { AllNotification } from "../components/Nofitication/AllNotification";
import EsgTheme from "../theme";
import IssbQuestionnaireRoundEditorPage from "../pages/ISSB/QuestionnaireRound/IssbQuestionnaireRoundEditorPage";
import IssbStageSetupPage from "../pages/ISSB/QuestionnaireRound/components/IssbStageSetupPage";
import AnswerDetailPage from "../pages/ISSB/IssbDataInput/AnswerDetailPage";
import InviteTeamPage from "../pages/ISSB/Onboarding/InviteTeamPage";
import DataInputPage from "../pages/ISSB/IssbDataInput/DataInputPage";
import IssbStartAudit from "../pages/ISSB/Audit/IssbStartAudit";
import IssbRequirementsPage from "../pages/ISSB/Requirements/IssbRequirementsPage";
import IssbTemplatePackagePage from "pages/ISSB/IssbTemplatePackagePage";
import IssbTemplateQuestionListPage from "pages/ISSB/IssbTemplateQuestionListPage";
import AuditControlPage from "../pages/ISSB/Audit/AuditControlPage";
import ReportDocListPage from "../pages/ISSB/ReportDocListPage";
import ReportDocEditorPage from "../pages/ISSB/ReportDocEditorPage";
import IssbCompleteAudit from "../pages/ISSB/Audit/IssbCompleteAudit";
import IssbPlanPublic from "../pages/IssbPlan/IssbPlanPublic";
import IssbDashboard from "../pages/ISSB/Dashboard/IssbDashboard";
import SourcesListPage from "pages/ISSB/Sources/SourcesListPage";
import AIReviewPage from "pages/ISSB/AIReview/AIReviewPage";
import AITasksListPage from "pages/ISSB/AITasks/AITasksListPage";
import AISettingsPage from "pages/ISSB/AISettingsPage";
import AboutAppPage from "pages/AboutAppPage";
import OrganizationList from "../pages/OrgMgmt/OrganizationList";
import OrganizationPage from "../pages/OrgMgmt/OrganizationPage";
import CompletedAuditInfo from "../pages/ISSB/Audit/components/CompletedAuditInfo";
import AgenticDashboard from "../pages/AgenticDashboard/AgenticDashboard";
import IssbTemplateQuestionEditorPage from "../pages/ISSB/IssbTemplateQuestionEditorPage";
import EmissionsInsights from "../pages/Reports/Insights/EmissionsInsights";
import SupplierInsights from "../pages/Reports/Insights/SupplierInsights";
import SupplierInsightEmissionDetail from "../pages/Reports/Insights/supplier-components/SupplierInsightEmissionDetail";
import SupplierIndividualDetail from "../pages/Reports/Insights/supplier-components/SupplierIndividualDetail";
import MODULES from "./modules";
import SupplierEngagement from "../pages/Reports/Insights/supplier-engagement/SupplierEngagement";
import FoundationDataPage from "../pages/ISSB/FoundationData/FoundationDataPage";
import FoundationAnswerDetailPage from "../pages/ISSB/FoundationData/FoundationAnswerDetailPage";

export const baseRoute = "/app";

export const companyEmissionsDashboardKey = "reportingPortalCompanyEmissionsDashboard";
export const netZeroStrategyKey = "netZeroStrategy";
export const supplierAdminDashboardKey = "supplierPortalSupplierDashboard";

/**
 * route-name -to-> route-path
 * 
 * Naming convention going forward:
 * 
The path `/{module}/{pageName}` with route name `{pageName}` should map to the page file `{page}Page.jsx`

This hasn't been followed historically -- let's move to this convention going forward, refactoring as we go.
 */
export const routes = {
  agenticDashboard: `${baseRoute}/agentic-dashboard`,
  dashboard: `${baseRoute}/dashboard`,
  [netZeroStrategyKey]: `${baseRoute}/net-zero-strategy`,

  reportingPortal: `${baseRoute}/reporting-portal`,
  [companyEmissionsDashboardKey]: `${baseRoute}/reporting-portal/company-emissions-dashboard`,
  reportingPortalCompanyReports: `${baseRoute}/reporting-portal/company-reports`,
  reportingPortalPhysicalRisk: `${baseRoute}/reporting-portal/physical-climate-risk`,
  reportingPortalInsights: `${baseRoute}/reporting-portal/insights`,
  reportingPortalSupplierInsights: `${baseRoute}/reporting-portal/supplier-insights`,
  supplierInsightEmissionDetail: `${baseRoute}/reporting-portal/supplier-insights/emission-detail`,
  supplierInsightsIndividualDetail: `${baseRoute}/reporting-portal/supplier-insights/individual-detail`,
  supplierInsightsEngagement: `${baseRoute}/reporting-portal/supplier-insights/engagement`,

  dataCollection: `${baseRoute}/data-collection`,
  dataCollectionDataEntryPlanning: `${baseRoute}/data-collection/data-entry-planning`,
  dataCollectionOrganisationQuestionnaires: `${baseRoute}/data-collection/organisation-questionnaires`,
  dataCollectionTaskAssigneesTemplate: `${baseRoute}/data-collection/task-assignees-template`,

  supplierPortal: `${baseRoute}/supplier-portal`,
  [supplierAdminDashboardKey]: `${baseRoute}/supplier-portal/supplier-dashboard`,
  supplierPortalSupplierManagement: `${baseRoute}/supplier-portal/supplier-management`,
  supplierPortalDataEntryPlanning: `${baseRoute}/supplier-portal/data-entry-planning`,
  supplierPortalViewEmissions: `${baseRoute}/supplier-portal/view-emissions`,
  supplierPortalViewEngagement: `${baseRoute}/supplier-portal/view-engagement`,
  supplierPortalSupplierSettings: `${baseRoute}/supplier-portal/supplier-settings`,
  supplierPortalSupplierNotes: `${baseRoute}/supplier-portal/supplier-notes`,

  csrd: `${baseRoute}/csrd`,
  csrdDataEntryPlanning: `${baseRoute}/csrd/data-entry-planning`,
  csrdQuestionnaires: `${baseRoute}/csrd/questionnaires`,
  csrdViewProgress: `${baseRoute}/csrd/view-progress`,
  csrdReport: `${baseRoute}/csrd/report`,

  knowledgeBase: `${baseRoute}/knowledge-base`,
  knowledgeBaseEsgExplorer: `${baseRoute}/knowledge-base/esg-explorer`,
  knowledgeBaseMaterialIssuesAndIndicators: `${baseRoute}/knowledge-base/material-issues-and-indicators`,
  knowledgeBaseCarbonPrice: `${baseRoute}/knowledge-base/carbon-price`,
  knowledgeBaseClimateActionTracker: `${baseRoute}/knowledge-base/climate-action-tracker`,
  knowledgeBaseClimatePolicyRadar: `${baseRoute}/knowledge-base/climate-policy-radar`,
  knowledgeBaseSustainableFinanceRegulation: `${baseRoute}/knowledge-base/sustainable-finance-regulation`,
  knowledgeBaseExposureToLitigation: `${baseRoute}/knowledge-base/exposure-to-litigation`,

  settings: `${baseRoute}/settings`,
  settingsUserManagement: `${baseRoute}/settings/user-management`,
  settingsMultimodalTransportation: `${baseRoute}/settings/multimodal-transportation`,
  settingsConversionFactors: `${baseRoute}/settings/conversion-factors`,
  settingsEntityManagement: `${baseRoute}/settings/entities`,
  settingsDimensionManagement: `${baseRoute}/settings/dimensions`,

  supplierDashboard: `${baseRoute}/supplier-dashboard`,
  supplierQuestionnaires: `${baseRoute}/supplier-questionnaires`,
  supplierQuestionnaire: `${baseRoute}/supplier-questionnaire`,
  supplierPhysicalRiskQuestionnaire: `${baseRoute}/supplier-physical-risk-questionnaire`,
  supplierNetZeroStrategy: `${baseRoute}/supplier-decarbonisation`,
  supplierNotes: `${baseRoute}/supplier-notes`,
  supplierResources: `${baseRoute}/supplier-resources`,

  supplierEmissionsReport: `${baseRoute}/supplier-emissions-report`,

  organisationQuestionnaire: `${baseRoute}/organisation-questionnaire`,
  csrdQuestionnaire: `${baseRoute}/csrd-questionnaire`,
  suppliersLocations: `${baseRoute}/suppliers-locations`,

  profile: `${baseRoute}/profile`,

  notification: `${baseRoute}/notification`,
  /** sales lead prospecting tool see IssbPlanPublic */
  esgLandscapeIssbPlanPublic: `/esg-landscape/issb-plan`,

  issbOnboarding: `${baseRoute}/issb/onboarding`,
  issbOnboardingInviteTeam: `${baseRoute}/issb/onboarding/invite-team`,
  issbDashboard: `${baseRoute}/issb/dashboard`,
  issbSources: `${baseRoute}/issb/sources`,
  issbDataInput: `${baseRoute}/issb/data-input`,
  issbQuestionnaireRound: `${baseRoute}/issb/questionnaire`,
  issbQuestionnaireRoundSetup: `${baseRoute}/issb/questionnaire/setup`,
  issbStageSetup: `${baseRoute}/issb/stage/setup`,
  issbTemplatePackage: `${baseRoute}/issb/template-package`,
  issbTemplateQuestionList: `${baseRoute}/issb/template-question`,
  issbTemplateQuestionEditor: `${baseRoute}/issb/template-question/:id`,
  aboutApp: `${baseRoute}/about-app`,
  issbAnswerDetail: `${baseRoute}/issb/data-input/answer`,

  sourcesList: `${baseRoute}/issb/sources/manage`,
  aiReview: `${baseRoute}/issb/ai-review`,
  aiTasksList: `${baseRoute}/issb/ai-tasks`,
  aiSettings: `${baseRoute}/settings/ai-settings`,
  settingsPrompts: `${baseRoute}/settings/prompts`,
  issbStartAudit: `${baseRoute}/issb/audit/start`,
  issbCloseAudit: `${baseRoute}/issb/audit/close`,
  issbCompletedAudit: `${baseRoute}/issb/audit/completed`,

  issbRequirements: `${baseRoute}/issb/requirements`,
  issbAuditControl: `${baseRoute}/issb/control`,
  issbDisclosure: `${baseRoute}/issb/disclosure`,
  issbReportDoc: `${baseRoute}/issb/report-doc`,
  reportDocEditor: `${baseRoute}/issb/report-doc/editor/:id`,
  foundationData: `${baseRoute}/issb/foundation-data`,
  foundationAnswerDetail: `${baseRoute}/issb/foundation-data/answer`,

  globalOrgManagement: `${baseRoute}/global-org-management`,
  organizationRoute: `${baseRoute}/organization/:id`,
};

/**
 * route-name -to-> list of Roles (Warning: not permissions!)
 * Roles are defined and set in Auth0 (used here via how??)
 */
export const permissions = {
  dashboard: ["ORG_ADMIN", "ORG_VIEWER"],
  [netZeroStrategyKey]: ["ORG_ADMIN"],

  reportingPortal: ["ORG_ADMIN", "ORG_VIEWER"],
  [companyEmissionsDashboardKey]: ["ORG_ADMIN", "ORG_VIEWER"],
  reportingPortalCompanyReports: ["ORG_ADMIN", "ORG_VIEWER"],
  reportingPortalPhysicalRisk: ["ORG_ADMIN", "ORG_VIEWER"],

  dataCollection: ["ORG_ADMIN", "ORG_MEMBER"],
  dataCollectionDataEntryPlanning: ["ORG_ADMIN"],
  dataCollectionOrganisationQuestionnaires: ["ORG_ADMIN", "ORG_MEMBER"],
  dataCollectionTaskAssigneesTemplate: ["ORG_ADMIN"],

  supplierPortal: ["ORG_ADMIN", "SUPPLIER_ADMIN", "ORG_VIEWER"],
  [supplierAdminDashboardKey]: ["ORG_ADMIN", "SUPPLIER_ADMIN", "ORG_VIEWER"],
  supplierPortalSupplierManagement: ["ORG_ADMIN", "SUPPLIER_ADMIN"],
  supplierPortalDataEntryPlanning: ["ORG_ADMIN", "SUPPLIER_ADMIN"],
  supplierPortalViewEmissions: ["ORG_ADMIN", "SUPPLIER_ADMIN", "ORG_VIEWER"],
  supplierPortalViewEngagement: ["ORG_ADMIN", "SUPPLIER_ADMIN", "ORG_VIEWER"],
  supplierPortalSupplierNotes: ["ORG_ADMIN", "SUPPLIER_ADMIN"],
  supplierPortalSupplierSettings: ["ORG_ADMIN", "SUPPLIER_ADMIN"],

  csrd: ["ORG_ADMIN", "CSRD_MEMBER"],
  csrdDataEntryPlanning: ["ORG_ADMIN"],
  csrdQuestionnaires: ["ORG_ADMIN", "CSRD_MEMBER"],
  csrdViewProgress: ["ORG_ADMIN", "CSRD_MEMBER"],
  csrdReport: ["ORG_ADMIN", "CSRD_MEMBER"],

  knowledgeBase: ["ORG_ADMIN", "ORG_MEMBER", "ORG_VIEWER"],
  knowledgeBaseEsgExplorer: ["ORG_ADMIN", "ORG_MEMBER", "ORG_VIEWER"],
  knowledgeBaseMaterialIssuesAndIndicators: ["ORG_ADMIN", "ORG_VIEWER"],
  knowledgeBaseCarbonPrice: ["ORG_ADMIN", "ORG_VIEWER"],
  knowledgeBaseClimateActionTracker: ["ORG_ADMIN", "ORG_VIEWER"],
  knowledgeBaseClimatePolicyRadar: ["ORG_ADMIN", "ORG_VIEWER"],
  knowledgeBaseSustainableFinanceRegulation: ["ORG_ADMIN", "ORG_VIEWER"],
  knowledgeBaseExposureToLitigation: ["ORG_ADMIN", "ORG_VIEWER"],

  settings: ["ORG_ADMIN"],
  settingsUserManagement: ["ORG_ADMIN"],
  settingsMultimodalTransportation: ["ORG_ADMIN"],
  settingsConversionFactors: ["ORG_ADMIN"],
  settingsEntityManagement: ["ORG_ADMIN"],
  settingsDimensionManagement: ["ESG_ADMIN"],
  settingsGlobalOrgManagement: ["ESG_ADMIN"],
  settingsOrganization: ["ESG_ADMIN"],
  settingsPrompts: ["ESG_ADMIN"],

  supplierDashboard: ["SUPPLIER", "SUPPLIER_VIEWER"],
  supplierQuestionnaires: ["SUPPLIER", "SUPPLIER_VIEWER"],
  supplierQuestionnaire: ["ORG_ADMIN", "SUPPLIER_ADMIN", "SUPPLIER", "SUPPLIER_VIEWER"],
  supplierPhysicalRiskQuestionnaire: ["ORG_ADMIN", "SUPPLIER_ADMIN", "SUPPLIER", "SUPPLIER_VIEWER"],
  supplierNetZeroStrategy: ["SUPPLIER", "SUPPLIER_VIEWER"],
  supplierNotes: ["SUPPLIER", "SUPPLIER_VIEWER"],
  supplierResources: ["SUPPLIER", "SUPPLIER_VIEWER"],

  organisationQuestionnaire: ["ORG_ADMIN", "ORG_MEMBER"],
  csrdQuestionnaire: ["ORG_ADMIN", "CSRD_MEMBER"],
  suppliersLocations: ["ORG_ADMIN", "SUPPLIER_ADMIN", "ORG_VIEWER"],

  supplierEmissionsReport: ["ORG_ADMIN", "SUPPLIER_ADMIN", "ORG_VIEWER"],

  profile: ["ORG_ADMIN", "SUPPLIER_ADMIN", "ORG_MEMBER", "SUPPLIER", "ORG_VIEWER", "SUPPLIER_VIEWER"],

  esgLandscapeIssbPlan: ["ORG_ADMIN", "ORG_VIEWER"],

  issbDashboard: ["ORG_ADMIN", "ORG_MEMBER"],
  foundationData: ["ORG_ADMIN", "ORG_VIEWER"],
  foundationAnswerDetail: ["ORG_ADMIN", "ORG_VIEWER"],
};

export const sideBarPages = [
  {
    name: "dashboard",
    module: "CarbonDashboard",
    linkProps: {
      to: routes.dashboard,
      icon: ChartPie,
      requiredPermissions: permissions.dashboard,
    },
    pathProps: {
      path: routes.dashboard,
      element: <Dashboard module="CarbonDashboard" componentRequiredPermissions={permissions.dashboard} />,
    },
  },
  {
    name: netZeroStrategyKey,
    module: "NetZero",
    linkProps: {
      to: routes[netZeroStrategyKey],
      icon: netZeroStrategySvgIcon,
      requiredPermissions: permissions[netZeroStrategyKey],
    },
    pathProps: {
      path: routes[netZeroStrategyKey],
      element: <NetZeroStrategy module="NetZero" componentRequiredPermissions={permissions[netZeroStrategyKey]} />,
    },
  },
  {
    name: "insights",
    module: MODULES.CarbonInsightsDashboard.id,
    mainRoute: routes.reportingPortal,
    linkProps: {
      icon: ChartBarHorizontal,
      requiredPermissions: permissions.reportingPortal,
    },
    subMenus: [
      {
        name: "reportingEmissionInsights",
        linkProps: {
          to: routes.reportingPortalInsights,
          icon: AiOutlineLineChart,
          requiredPermissions: permissions.reportingPortalCompanyReports,
        },
        pathProps: {
          path: routes.reportingPortalInsights,
          element: (
            <ChakraProvider theme={EsgTheme}>
              <EmissionsInsights
                module="CarbonReporting"
                componentRequiredPermissions={permissions.reportingPortalCompanyReports}
              />
            </ChakraProvider>
          ),
        },
      },
      {
        name: "reportingSupplierInsights",
        linkProps: {
          to: routes.reportingPortalSupplierInsights,
          icon: AiOutlineLineChart,
          requiredPermissions: permissions.reportingPortalCompanyReports,
        },
        pathProps: {
          path: routes.reportingPortalSupplierInsights,
          element: (
            <ChakraProvider theme={EsgTheme}>
              <SupplierInsights
                module="CarbonReporting"
                componentRequiredPermissions={permissions.reportingPortalCompanyReports}
              />
            </ChakraProvider>
          ),
        },
      },
    ],
  },
  {
    name: "reportingPortal",
    module: "CarbonReporting",
    mainRoute: routes.reportingPortal,
    linkProps: {
      icon: Planet,
      requiredPermissions: permissions.reportingPortal,
    },
    subMenus: [
      {
        name: companyEmissionsDashboardKey,
        linkProps: {
          to: routes[companyEmissionsDashboardKey],
          icon: BsPieChartFill,
          requiredPermissions: permissions[companyEmissionsDashboardKey],
        },
        pathProps: {
          path: routes[companyEmissionsDashboardKey],
          element: (
            <CompanyEmissionsDashboard
              module="CarbonReporting"
              componentRequiredPermissions={permissions[companyEmissionsDashboardKey]}
            />
          ),
        },
      },
      {
        name: "reportingPortalCompanyReports",
        linkProps: {
          to: routes.reportingPortalCompanyReports,
          icon: AiOutlineLineChart,
          requiredPermissions: permissions.reportingPortalCompanyReports,
        },
        pathProps: {
          path: routes.reportingPortalCompanyReports,
          element: (
            <EmissionsReports
              module="CarbonReporting"
              componentRequiredPermissions={permissions.reportingPortalCompanyReports}
            />
          ),
        },
      },
      {
        name: "reportingPortalPhysicalRisk",
        linkProps: {
          to: routes.reportingPortalPhysicalRisk,
          icon: AiFillAlert,
          requiredPermissions: permissions.reportingPortalPhysicalRisk,
        },
        pathProps: {
          path: routes.reportingPortalPhysicalRisk,
          element: (
            <PhysicalRisk
              module="CarbonReporting"
              componentRequiredPermissions={permissions.reportingPortalPhysicalRisk}
            />
          ),
        },
      },
    ],
  },
  {
    name: "dataCollection",
    module: "DataCollection",
    mainRoute: routes.dataCollection,
    linkProps: {
      icon: TreeStructure,
      requiredPermissions: permissions.dataCollection,
    },
    subMenus: [
      {
        name: "dataCollectionDataEntryPlanning",
        linkProps: {
          to: routes.dataCollectionDataEntryPlanning,
          icon: AiFillDatabase,
          requiredPermissions: permissions.dataCollectionDataEntryPlanning,
        },
        pathProps: {
          path: routes.dataCollectionDataEntryPlanning,
          element: (
            <OrganizationPlanning
              module="DataCollection"
              componentRequiredPermissions={permissions.dataCollectionDataEntryPlanning}
            />
          ),
        },
      },
      {
        name: "dataCollectionOrganisationQuestionnaires",
        linkProps: {
          to: routes.dataCollectionOrganisationQuestionnaires,
          icon: BsFillBarChartFill,
          requiredPermissions: permissions.dataCollectionOrganisationQuestionnaires,
        },
        pathProps: {
          path: routes.dataCollectionOrganisationQuestionnaires,
          element: (
            <OrganisationQuestionnaires
              module="DataCollection"
              componentRequiredPermissions={permissions.dataCollectionOrganisationQuestionnaires}
            />
          ),
        },
      },
      {
        name: "dataCollectionTaskAssigneesTemplate",
        linkProps: {
          to: routes.dataCollectionTaskAssigneesTemplate,
          icon: BsCollectionFill,
          requiredPermissions: permissions.dataCollectionTaskAssigneesTemplate,
        },
        pathProps: {
          path: routes.dataCollectionTaskAssigneesTemplate,
          element: (
            <TaskAssigneesTemplate
              module="DataCollection"
              componentRequiredPermissions={permissions.dataCollectionTaskAssigneesTemplate}
            />
          ),
        },
      },
    ],
  },
  {
    name: "supplierPortal",
    module: "SupplierPortal",
    mainRoute: routes.supplierPortal,
    linkProps: {
      icon: Truck,
      requiredPermissions: permissions.supplierPortal,
    },
    subMenus: [
      {
        name: supplierAdminDashboardKey,
        linkProps: {
          to: routes[supplierAdminDashboardKey],
          icon: BsPieChartFill,
          requiredPermissions: permissions[supplierAdminDashboardKey],
          group: {
            name: t("pages.dataReporting"),
            isFirstInGroup: true,
            isLastInGroup: false,
          },
        },
        pathProps: {
          path: routes[supplierAdminDashboardKey],
          element: (
            <SupplierAdminDashboard
              module="SupplierPortal"
              componentRequiredPermissions={permissions[supplierAdminDashboardKey]}
            />
          ),
        },
      },
      {
        name: "supplierPortalViewEmissions",
        linkProps: {
          to: routes.supplierPortalViewEmissions,
          icon: BsPassFill,
          requiredPermissions: permissions.supplierPortalViewEmissions,
          group: {
            name: t("pages.dataReporting"),
            isFirstInGroup: false,
            isLastInGroup: false,
          },
        },
        pathProps: {
          path: routes.supplierPortalViewEmissions,
          element: (
            <SuppliersEmissionsDashboard
              module="SupplierPortal"
              componentRequiredPermissions={permissions.supplierPortalViewEmissions}
            />
          ),
        },
      },
      {
        name: "supplierPortalViewEngagement",
        linkProps: {
          to: routes.supplierPortalViewEngagement,
          icon: AiOutlineAreaChart,
          requiredPermissions: permissions.supplierPortalViewEngagement,
          group: {
            name: t("pages.dataReporting"),
            isFirstInGroup: false,
            isLastInGroup: false,
          },
        },
        pathProps: {
          path: routes.supplierPortalViewEngagement,
          element: (
            <SupplierReports
              module="SupplierPortal"
              componentRequiredPermissions={permissions.supplierPortalViewEngagement}
            />
          ),
        },
      },
      {
        name: "supplierPortalDataEntryPlanning",
        linkProps: {
          to: routes.supplierPortalDataEntryPlanning,
          icon: AiFillDatabase,
          requiredPermissions: permissions.supplierPortalDataEntryPlanning,
          group: {
            name: t("pages.dataManagement"),
            isFirstInGroup: true,
            isLastInGroup: false,
          },
        },
        pathProps: {
          path: routes.supplierPortalDataEntryPlanning,
          element: (
            <SuppliersPlanning
              module="SupplierPortal"
              componentRequiredPermissions={permissions.supplierPortalDataEntryPlanning}
            />
          ),
        },
      },
      {
        name: "supplierPortalSupplierManagement",
        linkProps: {
          to: routes.supplierPortalSupplierManagement,
          icon: FaUserCog,
          requiredPermissions: permissions.supplierPortalSupplierManagement,
          group: {
            name: t("pages.dataManagement"),
            isFirstInGroup: false,
            isLastInGroup: false,
          },
        },
        pathProps: {
          path: routes.supplierPortalSupplierManagement,
          element: (
            <SupplierManagement
              module="SupplierPortal"
              componentRequiredPermissions={permissions.supplierPortalSupplierManagement}
            />
          ),
        },
      },
      {
        name: "supplierPortalSupplierNotes",
        linkProps: {
          to: routes.supplierPortalSupplierNotes,
          icon: GrNotes,
          requiredPermissions: permissions.supplierPortalSupplierNotes,
          group: {
            name: t("pages.dataManagement"),
            isFirstInGroup: false,
            isLastInGroup: false,
          },
        },
        pathProps: {
          path: routes.supplierPortalSupplierNotes,
          element: (
            <SupplierNotes
              module="SupplierPortal"
              componentRequiredPermissions={permissions.supplierPortalSupplierNotes}
            />
          ),
        },
      },
      {
        name: "supplierPortalSupplierSettings",
        linkProps: {
          to: routes.supplierPortalSupplierSettings,
          icon: BsFillGearFill,
          requiredPermissions: permissions.supplierPortalSupplierSettings,
          group: {
            name: t("pages.dataManagement"),
            isFirstInGroup: false,
            isLastInGroup: false,
          },
        },
        pathProps: {
          path: routes.supplierPortalSupplierSettings,
          element: (
            <SupplierSettings
              module="SupplierPortal"
              componentRequiredPermissions={permissions.supplierPortalSupplierSettings}
            />
          ),
        },
      },
    ],
  },
  {
    name: "csrd",
    module: "CSRD",
    mainRoute: routes.csrd,
    linkProps: {
      icon: BsCollectionFill,
      requiredPermissions: permissions.csrd,
    },
    subMenus: [
      {
        name: "csrdDataEntryPlanning",
        linkProps: {
          to: routes.csrdDataEntryPlanning,
          icon: AiFillDatabase,
          requiredPermissions: permissions.csrdDataEntryPlanning,
        },
        pathProps: {
          path: routes.csrdDataEntryPlanning,
          element: <CSRDPlanning module="CSRD" componentRequiredPermissions={permissions.csrdDataEntryPlanning} />,
        },
      },
      {
        name: "csrdQuestionnaires",
        linkProps: {
          to: routes.csrdQuestionnaires,
          icon: BsFillBarChartFill,
          requiredPermissions: permissions.csrdQuestionnaires,
        },
        pathProps: {
          path: routes.csrdQuestionnaires,
          element: <CSRDQuestionnaires module="CSRD" componentRequiredPermissions={permissions.csrdQuestionnaires} />,
        },
      },
      {
        name: "csrdViewProgress",
        linkProps: {
          to: routes.csrdViewProgress,
          icon: RiProgress3Fill,
          requiredPermissions: permissions.csrdViewProgress,
        },
        pathProps: {
          path: routes.csrdViewProgress,
          element: <CSRDViewProgress module="CSRD" componentRequiredPermissions={permissions.csrdViewProgress} />,
        },
      },
      {
        name: "csrdReport",
        linkProps: {
          to: routes.csrdReport,
          icon: AiOutlineLineChart,
          requiredPermissions: permissions.csrdReport,
        },
        pathProps: {
          path: routes.csrdReport,
          element: <CSRDReport module="CSRD" componentRequiredPermissions={permissions.csrdReport} />,
        },
      },
    ],
  },
  // Note: Removed old KB left-hand menu as, it was nice looking content, but out of date
  {
    name: "reportingAir",
    module: "AIR",
    mainRoute: routes.issbRequirements,
    linkProps: {
      icon: NotePencil,
      requiredPermissions: permissions.issbDashboard,
    },
    subMenus: [
      {
        name: "issbDashboard",
        hidden: true,
        linkProps: {
          to: routes.issbDashboard,
          icon: AiFillDatabase,
          requiredPermissions: permissions.issbDashboard,
        },
        pathProps: {
          path: routes.issbDashboard,
          element: (
            <ChakraProvider theme={EsgTheme}>
              <IssbDashboard module="AIR" componentRequiredPermissions={permissions.issbDashboard} />
            </ChakraProvider>
          ),
        },
      },
      {
        name: "foundationData",
        linkProps: {
          to: routes.foundationData,
          icon: AiFillDatabase,
          requiredPermissions: permissions.foundationData,
          requiredModules: [MODULES.FoundationData.id],
        },
        pathProps: {
          path: routes.foundationData,
          element: (
            <ChakraProvider theme={EsgTheme}>
              <FoundationDataPage />
            </ChakraProvider>
          ),
        },
      },
      {
        name: "issbRequirements",
        linkProps: {
          to: routes.issbRequirements,
          icon: AiFillDatabase,
          requiredPermissions: permissions.issbDashboard,
        },
        pathProps: {
          path: routes.issbRequirements,
          element: (
            <ChakraProvider theme={EsgTheme}>
              <IssbRequirementsPage module="AIR" componentRequiredPermissions={permissions.issbDashboard} />
            </ChakraProvider>
          ),
        },
      },
      {
        name: "Insights & Reports",
        linkProps: {
          to: routes.issbReportDoc,
          icon: AiFillDatabase,
          requiredPermissions: permissions.issbDashboard,
          requiredModules: [MODULES.AIReporting.id],
        },
        pathProps: {
          path: routes.issbReportDoc,
          element: (
            <ChakraProvider theme={EsgTheme}>
              <ReportDocListPage module="UNDER_DEVELOPMENT" componentRequiredPermissions={permissions.issbDashboard} />
            </ChakraProvider>
          ),
        },
      },
      {
        name: "issbAuditControl",
        hidden: true,
        linkProps: {
          to: routes.issbAuditControl,
          icon: AiFillDatabase,
          requiredPermissions: permissions.issbDashboard,
        },
        pathProps: {
          path: routes.issbAuditControl,
          element: (
            <ChakraProvider theme={EsgTheme}>
              <AuditControlPage module="AIR" componentRequiredPermissions={permissions.issbDashboard} />
            </ChakraProvider>
          ),
        },
      },
    ],
  },
  {
    // The Settings menu (left sidebar, but moving to top navbar)
    // TODO this should not duplicate definitions, e.g. for element.
    name: "settings",
    mainRoute: routes.settings,
    linkProps: {
      icon: GearSix,
      requiredPermissions: permissions.settings,
    },
    subMenus: [
      {
        name: "settingsUserManagement",
        linkProps: {
          to: routes.settingsUserManagement,
          icon: HiUsers,
          requiredPermissions: permissions.settingsUserManagement,
        },
        pathProps: {
          path: routes.settingsUserManagement,
          element: <Users componentRequiredPermissions={permissions.settingsUserManagement} />,
        },
      },
      {
        name: "settingsMultimodalTransportation",
        linkProps: {
          to: routes.settingsMultimodalTransportation,
          icon: FaLuggageCart,
          requiredPermissions: permissions.settingsMultimodalTransportation,
        },
        pathProps: {
          path: routes.settingsMultimodalTransportation,
          element: (
            <MultimodalTransportation componentRequiredPermissions={permissions.settingsMultimodalTransportation} />
          ),
        },
      },
      {
        name: "settingsConversionFactors",
        linkProps: {
          to: routes.settingsConversionFactors,
          icon: carbonDioxideSvgIcon,
          requiredPermissions: permissions.settingsConversionFactors,
        },
        pathProps: {
          path: routes.settingsConversionFactors,
          element: <ConversionFactors componentRequiredPermissions={permissions.settingsConversionFactors} />,
        },
      },
      {
        name: "settingsEntityManagement",
        linkProps: {
          to: routes.settingsEntityManagement,
          icon: HiMiniSquaresPlus,
          requiredPermissions: permissions.settingsEntityManagement,
        },
        pathProps: {
          path: routes.settingsEntityManagement,
          element: (
            <ChakraProvider theme={EsgTheme}>
              <EntityPage componentRequiredPermissions={permissions.settingsEntityManagement} />
            </ChakraProvider>
          ),
        },
      },
      {
        name: "settingsDimensionManagement",
        linkProps: {
          to: routes.settingsDimensionManagement,
          icon: TreeStructure,
          requiredPermissions: permissions.settingsDimensionManagement,
        },
        pathProps: {
          path: routes.settingsDimensionManagement,
          element: (
            <ChakraProvider theme={EsgTheme}>
              <DimensionManagementPage componentRequiredPermissions={permissions.settingsDimensionManagement} />
            </ChakraProvider>
          ),
        },
      },
      {
        name: "settingsConfigureWorkflowStages",
        linkProps: {
          to: routes.issbStageSetup,
          icon: HiMiniSquaresPlus,
        },
        pathProps: {
          path: routes.issbStageSetup,
          element: (
            <ChakraProvider theme={EsgTheme}>
              <IssbStageSetupPage />
            </ChakraProvider>
          ),
        },
      },
      {
        name: "aiSettings",
        linkProps: {
          to: routes.aiSettings,
          icon: HiMiniCog,
		  requiredPermissions: permissions.settingsGlobalOrgManagement,
        },
        pathProps: {
          path: routes.aiSettings,
          element: (
            <ChakraProvider theme={EsgTheme}>
              <AISettingsPage />
            </ChakraProvider>
          ),
        },
      },
      {
        name: "settingsPrompts",
        linkProps: {
          to: routes.settingsPrompts,
          icon: HiMiniDocumentText,
          requiredPermissions: permissions.settingsPrompts,
        },
        pathProps: {
          path: routes.settingsPrompts,
          element: (
            <ChakraProvider theme={EsgTheme}>
              <Prompts componentRequiredPermissions={permissions.settingsPrompts} />
            </ChakraProvider>
          ),
        },
      },
      {
        name: "aiTasksList", // TODO move elsewhere
        linkProps: {
          to: routes.aiTasksList,
          icon: HiMiniSquaresPlus,
          requiredPermissions: permissions.settingsGlobalOrgManagement,
        },
        pathProps: {
          path: routes.aiTasksList,
          element: (
            <ChakraProvider theme={EsgTheme}>
              <AITasksListPage />
            </ChakraProvider>
          ),
        },
      },
      {
        name: "issbTemplatePackage",
        linkProps: {
          to: routes.issbTemplatePackage,
          icon: HiMiniSquaresPlus,
          requiredPermissions: permissions.settingsGlobalOrgManagement,
        },
        pathProps: {
          path: routes.issbTemplatePackage,
          element: (
            <ChakraProvider theme={EsgTheme}>
              <IssbTemplatePackagePage />
            </ChakraProvider>
          ),
        },
      },
      {
        name: "globalOrgManagement",
        linkProps: {
          to: routes.globalOrgManagement,
          icon: HiMiniSquaresPlus,
          requiredPermissions: permissions.settingsGlobalOrgManagement,
        },
        pathProps: {
          path: routes.globalOrgManagement,
          element: (
            <ChakraProvider theme={EsgTheme}>
              <OrganizationList />
            </ChakraProvider>
          ),
        },
      },
      {
        name: "settingsAboutApp",
        linkProps: {
          to: routes.aboutApp,
          icon: HiMiniSquaresPlus,
        },
        pathProps: {
          path: routes.aboutApp,
          element: (
            <ChakraProvider theme={EsgTheme}>
              <AboutAppPage />
            </ChakraProvider>
          ),
        },
      },
    ],
  },
  {
    name: "supplierDashboard",
    linkProps: {
      to: routes.supplierDashboard,
      icon: BsPieChartFill,
      requiredPermissions: permissions.supplierDashboard,
    },
    pathProps: {
      path: routes.supplierDashboard,
      element: <SupplierDashboard componentRequiredPermissions={permissions.supplierDashboard} />,
    },
  },
  {
    name: "supplierQuestionnaires",
    linkProps: {
      to: routes.supplierQuestionnaires,
      icon: BsFillBarChartFill,
      requiredPermissions: permissions.supplierQuestionnaires,
    },
    pathProps: {
      path: routes.supplierQuestionnaires,
      element: <SupplierQuestionnaires componentRequiredPermissions={permissions.supplierQuestionnaires} />,
    },
  },
  {
    name: "supplierNetZeroStrategy",
    linkProps: {
      to: routes.supplierNetZeroStrategy,
      icon: netZeroStrategySvgIcon,
      requiredPermissions: permissions.supplierNetZeroStrategy,
    },
    pathProps: {
      path: routes.supplierNetZeroStrategy,
      element: <SupplierNetZeroStrategy componentRequiredPermissions={permissions.supplierNetZeroStrategy} />,
    },
  },
  {
    name: "supplierNotes",
    linkProps: {
      to: routes.supplierNotes,
      icon: GrNotes,
      requiredPermissions: permissions.supplierNotes,
    },
    pathProps: {
      path: routes.supplierNotes,
      element: <SupplierUserNotes componentRequiredPermissions={permissions.supplierNotes} />,
    },
  },
  {
    name: "supplierResources",
    linkProps: {
      to: routes.supplierResources,
      icon: GoFileMedia,
      requiredPermissions: permissions.supplierResources,
    },
    pathProps: {
      path: routes.supplierResources,
      element: <SupplierResources componentRequiredPermissions={permissions.supplierResources} />,
    },
  },
];

export const profilePages = [
  {
    name: "profile",
    pathProps: {
      path: routes.profile,
      element: <Text>Not Implemented yet</Text>,
    },
    linkProps: {
      to: routes.profile,
      requiredPermissions: permissions.profile,
    },
  },
];

/**
 name: Not used!!
 pathProps: The props for <Route /> from "react-router-dom" 
 linkProps: Not used!! For other sets of pages, a sidebar uses linkProps. For these pages it could be dropped.
 */
export const otherPages = [
  {
    name: "agenticDashboard",
    linkProps: {
      to: routes.agenticDashboard,
    },
    pathProps: {
      path: routes.agenticDashboard,
      element: (
        <ChakraProvider theme={EsgTheme}>
          <AgenticDashboard />
        </ChakraProvider>
      ),
    },
  },
  {
    name: "organisationQuestionnaire",
    linkProps: {
      to: routes.organisationQuestionnaire,
      requiredPermissions: permissions.organisationQuestionnaire,
    },
    pathProps: {
      path: routes.organisationQuestionnaire,
      element: (
        <OrganizationQuestionnaireWrapper componentRequiredPermissions={permissions.organisationQuestionnaire} />
      ),
    },
  },
  {
    name: "supplierQuestionnaire",
    linkProps: {
      to: routes.supplierQuestionnaire,
      requiredPermissions: permissions.supplierQuestionnaire,
    },
    pathProps: {
      path: routes.supplierQuestionnaire,
      element: <SupplierQuestionnaire componentRequiredPermissions={permissions.supplierQuestionnaire} />,
    },
  },
  {
    name: "supplierPhysicalRiskQuestionnaire",
    linkProps: {
      to: routes.supplierPhysicalRiskQuestionnaire,
      requiredPermissions: permissions.supplierPhysicalRiskQuestionnaire,
    },
    pathProps: {
      path: routes.supplierPhysicalRiskQuestionnaire,
      element: (
        <SupplierPhysicalRiskQuestionnaire
          componentRequiredPermissions={permissions.supplierPhysicalRiskQuestionnaire}
        />
      ),
    },
  },
  {
    name: "supplierEmissionsReport",
    linkProps: {
      to: routes.supplierEmissionsReport,
      requiredPermissions: permissions.supplierEmissionsReport,
    },
    pathProps: {
      path: routes.supplierEmissionsReport,
      element: <SupplierEmissionsReport componentRequiredPermissions={permissions.supplierEmissionsReport} />,
    },
  },
  {
    name: "csrdQuestionnaire",
    linkProps: {
      to: routes.csrdQuestionnaire,
      requiredPermissions: permissions.csrdQuestionnaire,
    },
    pathProps: {
      path: routes.csrdQuestionnaire,
      element: <CSRDQuestionnaireWrapper componentRequiredPermissions={permissions.csrdQuestionnaire} />,
    },
  },
  {
    name: "suppliersLocations",
    linkProps: {
      to: routes.suppliersLocations,
      requiredPermissions: permissions.suppliersLocations,
    },
    pathProps: {
      path: routes.suppliersLocations,
      element: <SuppliersLocations componentRequiredPermissions={permissions.suppliersLocations} />,
    },
  },
  {
    name: "notifications",
    pathProps: {
      path: routes.notification,
      element: <AllNotification />,
    },
  },
  {
    name: "issbTemplatePackage",
    pathProps: {
      path: routes.issbTemplatePackage,
      element: (
        <ChakraProvider theme={EsgTheme}>
          <IssbTemplatePackagePage />
        </ChakraProvider>
      ),
    },
  },
  {
    name: "issbTemplateQuestionList",
    pathProps: {
      path: routes.issbTemplateQuestionList,
      element: (
        <ChakraProvider theme={EsgTheme}>
          <IssbTemplateQuestionListPage />
        </ChakraProvider>
      ),
    },
  },
  {
    name: "issbQuestionnaireRoundSetup",
    pathProps: {
      path: routes.issbQuestionnaireRoundSetup,
      element: (
        <ChakraProvider theme={EsgTheme}>
          <IssbQuestionnaireRoundEditorPage />
        </ChakraProvider>
      ),
    },
  },
  {
    name: "issbStageSetup",
    pathProps: {
      path: routes.issbStageSetup,
      element: (
        <ChakraProvider theme={EsgTheme}>
          <IssbStageSetupPage />
        </ChakraProvider>
      ),
    },
  },
  {
    name: "issbAnswerDetail",
    pathProps: {
      path: routes.issbAnswerDetail,
      element: (
        <ChakraProvider theme={EsgTheme}>
          <AnswerDetailPage />
        </ChakraProvider>
      ),
    },
  },
  {
    name: "foundationAnswerDetail",
    pathProps: {
      path: routes.foundationAnswerDetail,
      element: (
        <ChakraProvider theme={EsgTheme}>
          <FoundationAnswerDetailPage />
        </ChakraProvider>
      ),
    },
  },
  {
    name: "issbOnboardingInviteTeam",
    pathProps: {
      path: routes.issbOnboardingInviteTeam,
      element: (
        <ChakraProvider theme={EsgTheme}>
          <InviteTeamPage />
        </ChakraProvider>
      ),
    },
  },
  {
    name: "sourcesList",
    pathProps: {
      path: routes.sourcesList,
      element: (
        <ChakraProvider theme={EsgTheme}>
          <SourcesListPage />
        </ChakraProvider>
      ),
    },
  },
  {
    name: "aiReview",
    pathProps: {
      path: routes.aiReview,
      element: (
        <ChakraProvider theme={EsgTheme}>
          <AIReviewPage />
        </ChakraProvider>
      ),
    },
  },
  {
    name: "reportDocEditor",
    pathProps: {
      path: routes.reportDocEditor,
      element: (
        <ChakraProvider theme={EsgTheme}>
          <ReportDocEditorPage />
        </ChakraProvider>
      ),
    },
  },
  {
    name: "aiTasksList",
    pathProps: {
      path: routes.aiTasksList,
      element: (
        <ChakraProvider theme={EsgTheme}>
          <AITasksListPage />
        </ChakraProvider>
      ),
    },
  },
  {
    name: "issbDataInput",
    pathProps: {
      path: routes.issbDataInput,
      element: (
        <ChakraProvider theme={EsgTheme}>
          <DataInputPage componentRequiredPermissions={permissions.issbDashboard} />
        </ChakraProvider>
      ),
    },
  },
  {
    name: "issbStartAudit",
    pathProps: {
      path: routes.issbStartAudit,
      element: (
        <ChakraProvider theme={EsgTheme}>
          <IssbStartAudit />
        </ChakraProvider>
      ),
    },
  },
  {
    name: "issbCloseAudit",
    pathProps: {
      path: routes.issbCloseAudit,
      element: (
        <ChakraProvider theme={EsgTheme}>
          <IssbCompleteAudit />
        </ChakraProvider>
      ),
    },
  },
  {
    name: "organization",
    pathProps: {
      path: routes.organizationRoute,
      element: (
        <ChakraProvider theme={EsgTheme}>
          <OrganizationPage />
        </ChakraProvider>
      ),
    },
    linkProps: {
      to: routes.organizationRoute,
      requiredPermissions: permissions.settingsOrganization,
    },
  },
  {
    name: "completedAudit",
    pathProps: {
      path: routes.issbCompletedAudit,
      element: (
        <ChakraProvider theme={EsgTheme}>
          <CompletedAuditInfo />
        </ChakraProvider>
      ),
    },
    linkProps: {
      to: routes.issbCompletedAudit,
    },
  },
  {
    name: "issbTemplateQuestionEditor",
    pathProps: {
      path: routes.issbTemplateQuestionEditor,
      element: (
        <ChakraProvider theme={EsgTheme}>
          <IssbTemplateQuestionEditorPage />
        </ChakraProvider>
      ),
    },
  },
  {
    name: "supplierInsightEmissionDetail",
    pathProps: {
      path: routes.supplierInsightEmissionDetail,
      element: (
        <ChakraProvider theme={EsgTheme}>
          <SupplierInsightEmissionDetail />
        </ChakraProvider>
      ),
    },
  },
  {
    name: "supplierInsightsIndividualDetail",
    pathProps: {
      path: routes.supplierInsightsIndividualDetail,
      element: (
        <ChakraProvider theme={EsgTheme}>
          <SupplierIndividualDetail />
        </ChakraProvider>
      ),
    },
  },
  {
    name: "supplierInsightsEngagement",
    pathProps: {
      path: routes.supplierInsightsEngagement,
      element: (
        <ChakraProvider theme={EsgTheme}>
          <SupplierEngagement />
        </ChakraProvider>
      ),
    },
  },
];

export const publicPages = [
  {
    path: routes.esgLandscapeIssbPlanPublic,
    element: <IssbPlanPublic />,
  },
];
